import styled from "styled-components";

// สไตล์รวมของทุกขั้นตอนจองที่นั่ง (Steps อยู่ใต้ container นี้) ขนาด/สีตาม design SMY Booking Seat v2
export const ActivitySeatBookingContainerStyled = styled.div`
  padding: 20px 16px 40px 16px;
  font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
  color: ${({ theme }) => theme.COLORS.BLACK_2};
  .seat_booking_container {
    margin: auto;
    max-width: ${({ theme }) => theme.ETC.ACTIVITY_DETAIL_WIDTH};
  }
  .lock_banner {
    margin-bottom: 20px;
    padding: 10px 14px;
    border-radius: 8px;
    background: #fff1d6;
    color: ${({ theme }) => theme.COLORS.ORANGE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S13};
    white-space: pre-wrap;
  }
  .closed_block {
    padding: 40px 0;
    display: flex;
    flex-direction: column;
    row-gap: 20px;
    text-align: center;
    color: ${({ theme }) => theme.COLORS.RED_1};
  }

  /* S2 เลือกที่นั่ง */
  .seat_select,
  .step_body {
    display: flex;
    flex-direction: column;
    row-gap: 18px;
  }
  .ss_section {
    display: flex;
    flex-direction: column;
    row-gap: 12px;
    &.ss_gap10 {
      row-gap: 10px;
    }
    &.ss_gap15 {
      row-gap: 15px;
    }
  }
  .ss_heading {
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
  }
  .ss_note {
    margin-top: 2px;
    color: #343a40;
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
  }
  .ss_hint {
    color: #595966;
    font-size: ${({ theme }) => theme.FONT.SIZE.S11};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
  }
  .map_box {
    position: relative;
    overflow: hidden;
    border: 1px solid ${({ theme }) => theme.COLORS.PURPLE_1};
    border-radius: 8px;
    > img {
      display: block;
      width: 100%;
      user-select: none;
    }
    .map_area {
      position: absolute;
      padding: 0;
      border: 2px solid transparent;
      border-radius: 6px;
      background: transparent;
      cursor: pointer;
      &.active {
        border-color: ${({ theme }) => theme.COLORS.WHITE_1};
        background: rgba(75, 30, 120, 0.25);
        box-shadow: 0 0 0 2px ${({ theme }) => theme.COLORS.PURPLE_1};
      }
    }
    .map_zoom {
      position: absolute;
      right: 8px;
      bottom: 8px;
      display: flex;
      padding: 4px;
      border: none;
      border-radius: 5px;
      background: ${({ theme }) => theme.COLORS.PURPLE_1};
      cursor: pointer;
    }
  }
  .map_zoom_modal {
    position: relative;
    z-index: 2;
    width: calc(100vw - 24px);
    max-width: 1000px;
    max-height: calc(100vh - 40px);
    overflow: auto;
    padding: 12px;
    border-radius: 10px;
    background: ${({ theme }) => theme.COLORS.WHITE_1};
    img {
      display: block;
      width: 100%;
      min-width: 600px;
      margin-bottom: 12px;
    }
  }
  /* ชิปโซนแถวละ 3 ตาม design */
  .zone_chips {
    display: grid;
    grid-template-columns: repeat(3, max-content);
    justify-content: center;
    gap: 10px 6px;
    .zone_chip {
      min-width: 77px;
      height: 42px;
      padding: 5px 12px;
      border: none;
      border-radius: 8px;
      background: #f2edfa;
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S11};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
      white-space: nowrap;
      cursor: pointer;
      &.active {
        background: ${({ theme }) => theme.COLORS.PURPLE_1};
        color: ${({ theme }) => theme.COLORS.WHITE_1};
      }
    }
  }
  .legend_row {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    color: #595966;
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    .legend_item {
      display: flex;
      align-items: center;
      column-gap: 6px;
      .box {
        width: 16px;
        height: 14px;
        border-radius: 3px;
      }
    }
  }
  /* แต่ละที่นั่งเป็นการ์ดแยกกันชัดเจน (สีเดียวกับกล่องสรุปราคา) */
  .seat_entry {
    display: flex;
    flex-direction: column;
    row-gap: 8px;
    padding: 12px 14px 14px;
    border: 1px solid #ced4da;
    border-radius: 10px;
    background: #f8f9fa;
  }
  .entry_head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    column-gap: 10px;
    min-height: 28px;
    .entry_remove {
      flex-shrink: 0;
      width: 76px;
      .btn {
        display: flex;
        justify-content: center;
        align-items: center;
        column-gap: 4px;
        padding: 0 10px;
        font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      }
      .prefix_label {
        display: flex;
      }
    }
  }
  .entry_selects {
    display: flex;
    column-gap: 20px;
    .entry_field {
      flex: 1;
      min-width: 0;
      display: flex;
      flex-direction: column;
      row-gap: 4px;
    }
    .entry_label {
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
      white-space: nowrap;
    }
  }
  .entry_viewer {
    display: flex;
    flex-direction: column;
    row-gap: 2px;
    .viewer_label {
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    }
    .viewer_input {
      width: 262px;
      max-width: 100%;
      height: 38px;
      padding: 0 10px 0 20px;
      border: 1px solid ${({ theme }) => theme.COLORS.PURPLE_1};
      border-radius: 20px;
      background: ${({ theme }) => theme.COLORS.WHITE_1};
      color: #212529;
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
      outline: none;
    }
  }
  .add_seat_row {
    margin-top: 10px;
    display: flex;
    align-items: center;
    column-gap: 12px;
    .add_seat_btn {
      flex-shrink: 0;
      width: 171px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 5px;
      border: 1px solid ${({ theme }) => theme.COLORS.PURPLE_1};
      border-radius: 24px;
      background: ${({ theme }) => theme.COLORS.WHITE_1};
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
      cursor: pointer;
      &:disabled {
        opacity: 0.5;
        cursor: default;
      }
    }
    .total_text {
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    }
  }
  .btn_row {
    margin-top: 12px;
    display: flex;
    column-gap: 16px;
    > div {
      flex: 1;
    }
  }

  /* S3 ข้อมูลผู้จอง */
  .form_row {
    margin-bottom: 14px;
  }
  .pdpa_note {
    margin-top: 10px;
    color: ${({ theme }) => theme.COLORS.GRAY_17};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
  }

  /* S4 ชำระเงิน / S5 ตรวจสอบ */
  .price_summary {
    display: flex;
    flex-direction: column;
    row-gap: 14px;
    padding: 14px 16px;
    border: 1px solid #ced4da;
    border-radius: 10px;
    background: #f8f9fa;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    .ps_label {
      margin-bottom: 4px;
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
    }
    .ps_total {
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
      .ps_total_amount {
        font-size: ${({ theme }) => theme.FONT.SIZE.S20};
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
      }
    }
    .ps_seat {
      display: flex;
      flex-direction: column;
      row-gap: 4px;
      word-break: break-word;
      .ps_seat_name {
        font-size: ${({ theme }) => theme.FONT.SIZE.S14};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
      }
      .ps_seat_price {
        color: #6c757d;
        font-size: ${({ theme }) => theme.FONT.SIZE.S12};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
      }
    }
  }
  .code_box {
    padding: 14px 16px;
    border-radius: 10px;
    background: #f2edfa;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
    .code_value {
      display: flex;
      column-gap: 10px;
      font-size: ${({ theme }) => theme.FONT.SIZE.S16};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
    }
    .code_hint {
      margin-top: 4px;
      white-space: pre-line;
    }
    .code_lock {
      margin-top: 4px;
      color: #eda44d;
      b {
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
        font-weight: normal;
      }
    }
  }
  /* กล่องแจ้งการชำระเงินแบบเดียวกับของเดิม (Music Hall) */
  .pay_card {
    padding: 12px;
    border: 1px solid #ced4da;
    border-radius: 10px;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    .pay_card_head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 10px;
      .pay_card_title {
        font-size: ${({ theme }) => theme.FONT.SIZE.S12};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
      }
      .pay_card_close {
        display: flex;
        padding: 2px;
        cursor: pointer;
      }
    }
    .pay_detail_title {
      margin-bottom: 8px;
      font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    }
    .pay_account {
      display: flex;
      column-gap: 30px;
      margin-bottom: 18px;
      font-size: ${({ theme }) => theme.FONT.SIZE.S11};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
      word-break: break-word;
      .pay_account_label {
        flex-shrink: 0;
        min-width: 50px;
      }
    }
    .account_qr {
      display: block;
      width: 100%;
      max-width: 320px;
      margin: 0 auto;
      border-radius: 6px;
    }
    .pay_download {
      display: block;
      margin: 18px 0 12px;
      text-align: center;
      color: inherit;
      text-decoration: none;
      font-size: ${({ theme }) => theme.FONT.SIZE.S11};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
      cursor: pointer;
    }
    .pay_upload {
      margin-top: 8px;
      .pay_upload_note {
        margin: 6px 0 0 8px;
        font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      }
      .pay_upload_ok {
        margin: 6px 0 0 8px;
        color: #34c759;
        font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      }
      .pay_upload_error {
        margin: 6px 0 0 8px;
        color: ${({ theme }) => theme.COLORS.RED_1};
        font-size: ${({ theme }) => theme.FONT.SIZE.S12};
      }
      .pay_upload_label {
        margin: 0 0 6px 8px;
        font-size: ${({ theme }) => theme.FONT.SIZE.S12};
        font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
      }
    }
  }

  /* S5 ตรวจสอบข้อมูล: แถบกลับไปแก้ไข แบบเดียวกับหน้าตรวจสอบของ Music Hall */
  .back_edit_bar {
    display: flex;
    align-items: center;
    column-gap: 14px;
    padding: 16px 0 16px 20px;
    border-top: 1px solid #adb5bd;
    border-bottom: 1px solid #adb5bd;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S13};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
    cursor: pointer;
  }
  .review_title {
    margin: 12px 0 8px;
    color: #ff383c;
    text-align: center;
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
  }
  .review_card {
    display: flex;
    flex-direction: column;
    row-gap: 4px;
    padding: 14px 16px;
    border-radius: 10px;
    background: #f2edfa;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_LIGHT};
    word-break: break-word;
    .rv_title {
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_SEMIBOLD};
    }
  }
  .rv_slip {
    display: flex;
    align-items: center;
    column-gap: 8px;
    padding-left: 16px;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S12};
    word-break: break-all;
    svg {
      flex-shrink: 0;
    }
  }
  .rv_btns {
    display: flex;
    flex-direction: column;
    row-gap: 24px;
    .rv_back {
      width: calc(50% - 8px);
    }
    .rv_submit {
      width: 100%;
      max-width: 294px;
      margin: 0 auto;
    }
  }

  /* S6 ส่งการจองแล้ว */
  .done_block {
    padding: 64px 0 40px;
    text-align: center;
    .done_title {
      color: ${({ theme }) => theme.COLORS.PURPLE_1};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    }
    .done_btn {
      max-width: 294px;
      margin: 150px auto 0;
    }
  }
  /* มือถือไม่มี breadcrumb เหมือนหน้ากิจกรรมเดิม (ขอบซ้ายขวา 16px ตาม design) */
  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    padding: 32px 16px 40px 16px;
    .breadcrumb_layout {
      display: none;
    }
  }
`;
